import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import cns from 'classnames';
import renderCarousel from '../../../shared/utils/CarouselUtils';

const WidgetCarousel = ({
    className,
    displayItems,
    disableCarousel,
    carouselSettings,
    widgetCarouselClassName,
    nextArrow,
    prevArrow
}) => {
    if (displayItems.length) {
        if (disableCarousel) {
            return <div className={cns(widgetCarouselClassName, className)}>{displayItems}</div>;
        }
        const dynamicCarouselSettings = renderCarousel(carouselSettings, displayItems.length);
        if (nextArrow) {
            dynamicCarouselSettings.nextArrow = nextArrow;
        }
        if (prevArrow) {
            dynamicCarouselSettings.prevArrow = prevArrow;
        }

        return (
            <div className={'col-12'} style={{ padding: '0' }}>
                <div className={cns('carousel-widget', widgetCarouselClassName, className)}>
                    <Slider {...dynamicCarouselSettings}>{displayItems}</Slider>
                </div>
            </div>
        );
    }
    return null;
};

WidgetCarousel.propTypes = {
    slidesToShow: PropTypes.number,
    className: PropTypes.string,
    displayItems: PropTypes.array,
    disableCarousel: PropTypes.bool,
    carouselSettings: PropTypes.string,
    widgetCarouselClassName: PropTypes.string,
    nextArrow: PropTypes.element,
    prevArrow: PropTypes.element
};

export default WidgetCarousel;
